import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CountDownComponent } from '@components/count-down/count-down.component';
import { RatingComponent } from '@components/forms/rating/rating.component';
import { IconComponent } from '@components/icon/icon.component';
import { ImageFailedDirective } from '@directives/image-failed.directive';
import { Product } from '@models/product.model';
import { ImagePipe } from '../../../core/pipes/image.pipe';
import { VndPipe } from '../../../core/pipes/vnd.pipe';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NO_PERMISSIONS } from '@models/users.model';

@Component({
  selector: 'market-carousel-product-item[product]',
  standalone: true,
  templateUrl: './carousel-product-item.component.html',
  styleUrls: ['./carousel-product-item.component.scss'],
  imports: [
    CommonModule,
    ImagePipe,
    VndPipe,
    IconComponent,
    RouterModule,
    RatingComponent,
    FormsModule,
    ImageFailedDirective,
    CountDownComponent,
    NgxPermissionsModule,
  ],
})
export class CarouselProductItemComponent {
  @Input() product!: Product;
  @Input() editable = false;
  @Output() addToCart = new EventEmitter<Product>();
  @Output() updateProduct = new EventEmitter();

  get guest() {
    return NO_PERMISSIONS;
  }

  updateProductHandler($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
    this.updateProduct.emit();
  }
  cartButtonClickHandler($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
    this.addToCart.emit(this.product);
  }
}
